export const memberCountPlural = "v2gGRd";
export default {memberCountPlural};